import { ObjectValues } from '@stadionhq-v3/core';

export const FIXTURE_TYPE = {
  RESULTS: 'results',
  FIXTURES: 'fixtures',
  TABLE: 'table',
} as const;

export type FixtureType = ObjectValues<typeof FIXTURE_TYPE>;
